<template>
  <div @click="$emit('open:app', service)" :locked="appsLocked || locked" :type="type" class="workspaceAppCard">
    <div :type="type" :status="workspace.status" :online-status="service.onlineStatus" class="appHeaderContainer">
      <app-header
        @set:online="state => $emit('set:online', state, serviceId)"
        :online-state="service.onlineStatus"
        :is-deployed="serviceDeployed"
        :loading="loading"
        :workspace="workspace"
        :app-id="service.id"
        :running-since="service.runningSince"
        :flag-type="type"
      />
    </div>

    <div class="appBodyContainer" rbt-target="appContainer">
      <app-body
        @copy:password="$emit('copy:password')"
        :app-is-deployed="serviceDeployed"
        :is-deployed="workspaceIsDeployed"
        :loading="loading"
        :app-model="serviceModel"
        :workspace="workspace"
        :app="service"
        :flag-type="type"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from "@vue/composition-api"
import { WorkspaceModule } from "@/store/workspace"
import { AppDiffType } from "@/utils/workspaceDiff"
import { WorkspaceStates } from "@/config/workspace-states"
import AppHeader from "./AppHeader.vue"
import AppBody from "./AppBody.vue"
import AppFooter from "./AppFooter.vue"

import {
  WorkspaceOnlineStatusEnum,
  WorkspaceStatusEnum,
  WorkspaceTemplate,
  Service,
  ServiceModel
} from "@/types/workspace"

export default defineComponent({
  name: "ServiceCard",
  props: {
    service: {
      type: Object as PropType<Service>,
      required: true
    },
    deploy: {
      type: String as PropType<WorkspaceStatusEnum>,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    locked: {
      type: Boolean,
      default: false
    },
    type: {
      type: String as PropType<`${AppDiffType}`>,
      required: true
    },
    workspace: {
      type: Object as PropType<WorkspaceTemplate>,
      required: true
    }
  },
  setup(props) {
    const workspaceModule = WorkspaceModule()

    const appsLocked = computed(() => {
      return WorkspaceStates.isLoading(props.deploy)
    })

    const serviceModel = computed(() => {
      return workspaceModule.serviceModels.find(service => {
        return service.type === props.service.type
      }) as ServiceModel
    })

    const serviceId = computed(() => {
      return props.service.id
    })

    const serviceDeployed = computed(() => {
      const { schemaDeployed } = props.workspace

      if (schemaDeployed) {
        return schemaDeployed.services.some(service => service.id === props.service.id)
      }

      return false
    })

    const wasRemoved = computed(() => {
      return props.type === "removed"
    })

    const serviceOnline = computed(() => {
      return props.service.onlineStatus === WorkspaceOnlineStatusEnum.Online
    })

    const workspaceIsDeployed = computed(() => {
      return WorkspaceStates.isDeployed(props.workspace.status)
    })

    return {
      workspaceIsDeployed,
      wasRemoved,
      serviceOnline,
      serviceModel,
      appsLocked,
      serviceDeployed,
      serviceId
    }
  },
  components: {
    AppHeader,
    AppBody,
    AppFooter
  }
})
</script>
